import { Link } from "gatsby"
import React from "react"
import flatartLogo from "../assets/img/flatart-logo.png"

const Footer = () => (
    <footer>

        <div className="footer-bottom">
            <div className="footer-bottom_content">
                <h2>Tanışalım.</h2>
                <p><a href="mailto:hello@theflatart.com" >E-posta</a> veya <a href="tel:+90(850)9880200">telefon</a> aracılığıyla iletişime geçelim</p>
                <p>ya da ajansımızda birer kahve içelim.</p>
            </div>
            <div className="footer-bottom_links container">
                <div className="col-md-3 social" style={{ textAlign: "center" }}>
                    <img className="footer-logo" alt="Flatart logo" src={flatartLogo} />
                    <p><u><a href="https://www.instagram.com/flatart.agency">Ins.</a></u> <u><a href="https://dribbble.com/flatart">Drb.</a></u> <u><a href="http://www.faceobok.com/flatart.agency">Fck.</a></u> <u><a href="https://www.linkedin.com/company/flatart-agency">In.</a></u></p>
                </div>
                <div className="col-md-3">
                    <h3>Hizmetler</h3>
                    <ul>
                    <li><Link to="/arama-motoru-optimizasyonu/">Arama Motoru Optimizasyonu</Link></li>
                    <li><Link to="/web-mobil-gelistirme/">Web & Mobil Geliştirme</Link></li>
                    <li><Link to="/sosyal-medya/">Sosyal Medya Yönetimi</Link></li>
                    <li><Link to="/eposta-pazarlama/">E-posta Pazarlama</Link></li>
                    <li><Link to="/ui-ux-tasarim/">UI/UX Tasarım</Link></li>
                    <li><Link to="/google-ads/">Google Ads</Link></li>


                    </ul>
                </div>
               
                <div className="col-md-3">
                    <h3>Çözümler</h3>
                    <ul>
                        <li><Link to="/trafik-edinme/">Trafik Edinme</Link></li>
                        <li><Link to="/donusum/">Dönüşüm</Link></li>
                        <li><Link to="/analiz/">Analiz</Link></li>
                        {/* <li><Link to="#">Lead Generation</Link></li> */}
                        {/* <li><Link to="#">CRO</Link></li> */}
                    </ul>
                </div>
                <div className="col-md-3">
                    <h3>Flatart Agency</h3>
                    <ul>
                        <li><Link to="/hakkimizda/">Hakkımızda</Link></li>
                        <li><Link to="/hakkimizda/">Tanışalım</Link></li>
                        <li><Link to="/markalar/">Markalar</Link></li>
                        <li><Link to="/iletisim/">İletişim</Link></li>
                        <li><Link to="/hakkimizda/#ekip">Ekip</Link></li>
                        <li><Link to="/hakkimizda/#ik">İK</Link></li>
                        {/* <li><Link to="#">Analiz Danışmanlığı</Link></li>
                        <li><Link to="#">Analitik Entegrasyonlar</Link></li>
                        <li><Link to="#">Büyüme Planı</Link></li> */}
                    </ul>
                </div>
               
            </div>
            <div className="footer-bottom_end">
                <div className="footer-bottom_end-content container">
                    <p>flatart 2019 Tüm Hakları Saklıdır. | flatart, bir A Grafik iştirakidir.</p>
                    <ul>
                    <li><Link to="/gizlilik-sozlesmesi/">Gizlilik Sözleşmesi</Link></li>
                        <li><Link to="/kullanici-antlasmasi/">Kullanıcı Antlaşması</Link></li>
                        <li><a target="_blank" href="https://popupsmart.com">Popupsmart</a></li>
                        {/* <li><Link to="#">Gizlilik Sözleşmesi</Link></li> */}
                        {/* <li><Link to="#">Kullanım Koşulları</Link></li> */}
                    </ul>
                </div>
            </div>
            
        </div>

    </footer>

)

export default Footer
